import { render, staticRenderFns } from "./CardReferenceWidget.vue?vue&type=template&id=43d89baa&scoped=true"
import script from "./CardReferenceWidget.vue?vue&type=script&lang=js"
export * from "./CardReferenceWidget.vue?vue&type=script&lang=js"
import style0 from "./CardReferenceWidget.vue?vue&type=style&index=0&id=43d89baa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d89baa",
  null
  
)

export default component.exports